'use client';

import { __spreadArray, __assign } from '../_virtual/_tslib.js';
import { DEFAULT_COLORS, DEFAULT_MAX_RADIUS, DEFAULT_MINUS_RADIUS } from './constants.js';

var findSortedIndex = function (item, sortLargest) {
    var filteredItem = sortLargest.filter(function (sortItem) { return sortItem.label === item.label && sortItem.percent === item.percent; });
    return filteredItem.length > 0 ? filteredItem[0] : null;
};
/**
 * Return list of TValueItem with sorted from largest to smallest
 * @param value list of TValueItem
 * @returns sorted from largest to smallest
 */
var getListLevel = function (value) {
    var sortedRadiusLevel = [];
    var clonedValue = __spreadArray([], value, true);
    var sortLargest = clonedValue.sort(function (a, b) { return (a.percent > b.percent ? -1 : 0); });
    var _loop_1 = function (i) {
        var item = sortLargest[i];
        var filteredLevels = sortedRadiusLevel.filter(function (childItem) { return childItem.percent === item.percent; });
        if (filteredLevels.length <= 0) {
            sortedRadiusLevel.push(item);
        }
    };
    // Reduce duplicate percent item
    for (var i = 0; i < sortLargest.length; i++) {
        _loop_1(i);
    }
    var _loop_2 = function (i) {
        var item = sortLargest[i];
        var itemIndex = sortedRadiusLevel.findIndex(function (childItem) { return childItem.percent === item.percent; });
        if (itemIndex >= 0) {
            sortLargest[i].radiusIndex = itemIndex;
        }
    };
    // Find item and update radius level
    for (var i = 0; i < sortLargest.length; i++) {
        _loop_2(i);
    }
    return sortLargest;
};
/**
 * Map list of TValueItem with color and minusRadius
 * @param value list of TValueItem
 * @param sortLargest list of TValueItem are sorted by percent from largest to smallest
 * @returns list of TValueItem with color and minusRadius
 */
var mapRadiusIndex = function (value, sortLargest, highlightColor) {
    return value.map(function (item, index) {
        var _a, _b;
        // get index of sorted
        var sortItemInfo = findSortedIndex(item, sortLargest);
        var sortItemIndex = (_a = sortItemInfo === null || sortItemInfo === void 0 ? void 0 : sortItemInfo.radiusIndex) !== null && _a !== void 0 ? _a : 0;
        // Calculate minusRadius by sorted index of radius level
        var minusRadius = DEFAULT_MAX_RADIUS - sortItemIndex * DEFAULT_MINUS_RADIUS;
        var itemColor = (_b = item.color) !== null && _b !== void 0 ? _b : DEFAULT_COLORS[index];
        if (item.isActive) {
            itemColor = highlightColor;
        }
        return __assign(__assign({ index: index }, item), { radiusIndex: sortItemIndex, color: itemColor, minusRadius: minusRadius });
    });
};
/**
 * Check have only one value
 * @param value list of TValueItem
 * @returns Object with TValueItem and boolean variable (have one value or not)
 */
var findOnlyOneValue = function (value) {
    var _a;
    var isHaveOneValue = false;
    var filteredValues = value.filter(function (item) { return item.percent === 100; });
    if (filteredValues.length > 0) {
        isHaveOneValue = true;
    }
    // get index
    var filteredIndexValue = value.findIndex(function (item) { return item.percent === 100; });
    return {
        value: value,
        isHaveOneValue: isHaveOneValue,
        onlyValue: (_a = filteredValues[0]) !== null && _a !== void 0 ? _a : null,
        onlyValueIndex: filteredIndexValue
    };
};

export { findOnlyOneValue, getListLevel, mapRadiusIndex };
//# sourceMappingURL=helper.js.map
